/**
 * Auto-guard на основі path → permission mapping (Порція 3.0.5.5).
 *
 * Альтернатива до огортання кожного <Route> в RouteGuard окремо. Тут
 * читаємо поточний URL через useLocation, шукаємо потрібний permission
 * у `routePermissions.ts` і блокуємо/redirect.
 *
 * Розміщується ОДИН раз у AppLayout, перед <Outlet />. Завдяки React
 * Router rerender при кожному location change — guard працює для всіх
 * вкладених routes автоматично.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from './usePermissions';
import { permissionForPath } from './routePermissions';

export default function AutoRouteGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { has, isLoading } = usePermissions();

  // Поки me ще loading — не блокуємо.
  if (isLoading) return <>{children}</>;

  const requiredPerm = permissionForPath(location.pathname);
  if (requiredPerm === null) return <>{children}</>;

  if (!has(requiredPerm)) {
    // Захист: redirect на home. У 99% випадків Sidebar уже сховав цей
    // link, тому сюди потрапляють лише ті, хто ввів URL вручну або
    // прийшов за bookmark'ом застарілих прав.
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
